import { ObjectKeys } from 'common/helpers'
import type { MouseEvent as ReactMouseEvent } from 'react'

const MouseButton = {
  Left: 0,
  Middle: 1,
  Right: 2,
  Back: 3,
  Forward: 5,
} as const

const Keys = ObjectKeys(MouseButton)
type ButtonPredicate = (e: MouseEvent | ReactMouseEvent) => boolean

export const isButtonOfType = Object.fromEntries(
  Object.entries(MouseButton).map(([type, value]) => [
    type,
    (e: MouseEvent | ReactMouseEvent): boolean => {
      return e.button === value
    },
  ]),
) as Record<(typeof Keys)[number], ButtonPredicate>
